<mwe-modal [model]="popupModel()">
  <p [innerHTML]="'cookie-banner.text' | translate | safeHtml"></p>
  <form [formGroup]="formGroup">
    <div formArrayName="cookieGroups">
      @for (groupControl of cookieGroups()?.controls; track $index; let i = $index) {
        @if (!$first) {
          <hr class="my-4" />
        }
        <div [formGroupName]="i" class="row gx-2 mb-4">
          <div class="col-auto">
            <div class="switch-v2">
              <input
                id="cookie-toggle-group-{{ groupControl.get('id')?.value }}"
                type="checkbox"
                class="checkbox"
                formControlName="accepted"
                data-test="wizard-product-card-container-toggle"
                [attr.aria-label]="'cookie-banner.aria.group-toggle' | translate: { group: getGroupData(i)?.title }"
              />
              <div class="switch-v2-knob"></div>
            </div>
          </div>
          <div class="col">
            <div class="h5 mb-1">{{ getGroupData(i)?.title }}</div>
            <div class="row g-1" style="font-size: 0.75rem">
              <div class="col-auto"><i class="fas fa-circle-exclamation" aria-hidden="true"></i></div>
              <div class="col">
                <p class="mb-0">
                  @if (getGroupData(i)?.services?.length) {
                    @let translationString =
                      getGroupData(i)?.services?.length === 1
                        ? 'cookie-banner.group.third-party-service'
                        : 'cookie-banner.group.third-party-services';
                    {{ translationString | translate: { serviceCount: getGroupData(i)?.services?.length } }}
                    <br />
                  }
                  {{ getGroupData(i)?.description }}
                </p>
              </div>
            </div>
          </div>
          @if (getGroupData(i)?.services?.length) {
            <div class="col-auto">
              @let labelKey = collapse.isClosed() ? 'cookie-banner.aria.group-more' : 'cookie-banner.aria.group-less';
              <mwe-button-link
                [label]="collapse.isClosed() ? 'cookie-banner.collapse.group.more' : 'cookie-banner.collapse.group.less'"
                [appendIconClass]="collapse.isClosed() ? 'fas fa-chevron-down' : 'fas fa-chevron-up'"
                (clicked)="collapse.toggle()"
                [ariaLabel]="labelKey | translate: { group: getGroupData(i)?.title }"
              />
            </div>
            <div class="col-12">
              <div #collapse="mweCollapse" [mweCollapse]="true" class="pl-3">
                <div formArrayName="services">
                  @for (serviceControl of getServicesArray(i).controls; track $index; let j = $index) {
                    <div [formGroupName]="j" class="row g-2 mt-12px">
                      <div class="col-auto">
                        <div class="switch-v2">
                          <input
                            id="cookie-toggle-service-{{ serviceControl.get('id')?.value }}"
                            type="checkbox"
                            class="checkbox"
                            formControlName="accepted"
                            data-test="wizard-product-card-container-toggle"
                            [attr.aria-label]="'cookie-banner.aria.service-toggle' | translate: { service: getServiceData(i, j)?.name }"
                          />
                          <div class="switch-v2-knob"></div>
                        </div>
                      </div>
                      <div class="col">
                        <div class="h5 mb-1">{{ getServiceData(i, j)?.name }}</div>
                        <div class="row g-1" style="font-size: 0.75rem">
                          <div class="col-auto"><i class="fas fa-circle-exclamation" aria-hidden="true"></i></div>
                          <div class="col">
                            <p class="mb-0">
                              {{ getServiceData(i, j)?.company }}
                            </p>
                            <div #innerCollapse="mweCollapse" [mweCollapse]="true">
                              <p [innerHTML]="getServiceData(i, j)?.details | safeHtml"></p>
                            </div>
                          </div>
                        </div>
                      </div>
                      @if (getServiceData(i, j)?.details) {
                        <div class="col-auto">
                          @let serviceLabelKey =
                            innerCollapse.isClosed() ? 'cookie-banner.aria.service-more' : 'cookie-banner.aria.service-less';
                          <mwe-button-link
                            label="cookie-banner.collapse.service"
                            [appendIconClass]="innerCollapse.isClosed() ? 'fas fa-chevron-down' : 'fas fa-chevron-up'"
                            (clicked)="innerCollapse.toggle()"
                            [ariaLabel]="serviceLabelKey | translate: { service: getServiceData(i, j)?.name }"
                          />
                        </div>
                      }
                    </div>
                  }
                </div>
              </div>
            </div>
          }
        </div>
      }
    </div>
  </form>

  <ng-container slot="header-col">
    <div class="col-lg col-12 order-1 order-lg-0 text-center">
      <div class="row g-2 justify-content-center justify-content-lg-end">
        <div class="col-auto"><a href="#" class="link text-white fw-bold focus-inverted">Impressum</a></div>
        <div class="col-auto"><a href="#" class="link text-white fw-bold focus-inverted">Datenschutzinformation</a></div>
      </div>
    </div>
  </ng-container>

  <ng-container slot="footer">
    <div class="p-4 bg-gray--200">
      <div class="row g-3 justify-content-between">
        <div class="col-md-auto">
          <mwe-button
            category="secondary"
            labelKey="cookie-banner.buttons.accept"
            data-test="cookie-consent-accept-selection-button"
            [hasFullWidth]="true"
            (clicked)="acceptSelection()"
          />
        </div>
        <div class="col-md-auto">
          <mwe-button
            labelKey="cookie-banner.buttons.accept-all"
            data-test="cookie-consent-accept-all-button"
            [hasFullWidth]="true"
            (clicked)="acceptSelection(true)"
          />
        </div>
      </div>
    </div>
  </ng-container>
</mwe-modal>
